<script>
import { getProjectKeywordRanks } from '@/api/v2/projects';
import axios from 'axios';

export default {
  render() {
    return null;
  },
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      keywordRanks: {}
    };
  },
  watch: {
    project: {
      handler(project) {
        // プロジェクトが未選択、プロジェクトがGA4未連携、自社キーワード分析にいる場合は何もしない
        if (
          !project.id ||
          !project.ga4AccountId ||
          this.$route.name === 'siteKeywordAnalysis'
        ) {
          return;
        }
        this.initKeywordRanks(project.id);
        this.prefetchKeywordRanks(project.id);
      }
    },
    '$route.name': {
      handler(routeName) {
        if (
          !this.project.id ||
          !this.project.ga4AccountId ||
          routeName !== 'siteKeywordAnalysis'
        ) {
          return;
        }
        // 自社キーワード分析にアクセスした場合はリクエストをキャンセルする
        this.cancelPrefetchKeywordRanks(this.project.id);
      }
    }
  },
  methods: {
    initKeywordRanks(projectId) {
      // 初期化済みの場合は何もしない
      if (this.keywordRanks[projectId]) {
        return;
      }
      this.keywordRanks[projectId] = {
        cancelTokenSource: null,
        isFetched: false,
        isFetching: false
      };
    },
    prefetchKeywordRanks(projectId) {
      // フェッチ済みもしくはフェッチ中の場合は何もしない
      if (
        !this.keywordRanks[projectId] ||
        this.keywordRanks[projectId].isFetched ||
        this.keywordRanks[projectId].isFetching
      ) {
        return;
      }
      this.keywordRanks[projectId].isFetching = true;

      const params = { device: 'desktop' };
      const cancelTokenSource = axios.CancelToken.source();
      this.keywordRanks[projectId].cancelTokenSource = cancelTokenSource;

      // ブラウザにキャッシュさせることが目的なので、レスポンスが返ってきても何もしない
      getProjectKeywordRanks({
        cancelToken: cancelTokenSource.token,
        idToken: this.auth.idToken,
        params,
        projectId: projectId
      })
        .then(() => {
          this.keywordRanks[projectId].isFetched = true;
          this.keywordRanks[projectId].isFetching = false;
        })
        .catch(() => {
          this.keywordRanks[projectId].isFetching = false;
        });
    },
    cancelPrefetchKeywordRanks(projectId) {
      if (
        !this.keywordRanks[projectId] ||
        !this.keywordRanks[projectId].cancelTokenSource
      ) {
        return;
      }
      this.keywordRanks[projectId].cancelTokenSource.cancel();
      this.keywordRanks[projectId].cancelTokenSource = null;
    }
  }
};
</script>
